<form [formGroup]="form">
  <div class="row" *transloco="let t">
     <div class="col-lg-12 pb-3 alipay__check_label" *ngIf="gd?.oscConfig?.displayShpngAsBillngNam">
        <input type="checkbox" id="sameAsShippingContactName" name="sameAsShippingContactName"
           formControlName="sameAsShippingContactName" (change)="sameNamecheckbox($event)" />
        <label class="ps-2 address_label font_family__standard" for="sameAsShippingContactName">
          {{t('billing.same.shipping')}}
        </label>
     </div>
     <div class="alipay__name_info">
        <div class="col-lg-12 col-sm-12 col-md-12 pb-3">
          <label for="firstName">
            <span class="bilng_adrs_details__label font_family__standard">
             {{t('alipay.first.name')}}
            </span>
            <span class="required-asterisk">*</span>
          </label>
          <input id="firstName" name="firstName" class="form-control form-control-md" formControlName="firstName"  required />
          <span *ngIf="
            (form.controls['firstName'].hasError('required') || form.controls['firstName'].hasError('minLength')) &&
            form.controls['firstName'].touched
            " class="text-danger">
          {{t('billing.error.alipay.first.name')}}</span>
      </div>
      <div class="col-lg-12 col-sm-12 pb-3">
          <label for="lastName">
            <span class="bilng_adrs_details__label font_family__standard">
              {{t('alipay.last.name')}}
            </span>
            <span class="required-asterisk">*</span>
          </label>
          <input id="lastName" name="lastName" class="form-control form-control-md" formControlName="lastName"
            required />
          <span *ngIf="
            (form.controls['lastName'].hasError('required') || form.controls['lastName'].hasError('minLength')) &&
            form.controls['lastName'].touched
            " class="text-danger">
          {{t('billing.error.alipay.last.name')}}</span>
      </div>
     </div>
  </div>
</form>
